//  FMSDJ-2 Divyani 9/4/2021
//  FMSDJ-14 vidit 19/04/2021
//  FMSDJ-2 Divyani 19/4/2021
//  FMSDJ-2 Divyani 20/4/2021
// FMSDJ-2 riddhi 21/4/2021
// FMSDJ-2 riddhi 23/4/2021 
// FMSDJ-4 ridhi 28/04/2021
// FMSDJ-17 ridhi 29/04/2021
// FMSDJ-19 riddhi 27/5/2021 
$( document ).ready(function() {
  var window_height = $(window).height();
  var headeheight = $('header').outerHeight();
  var footeheight = $('footer').height();
  var sub_total = headeheight + footeheight;
  var total_height = window_height - sub_total;
  $('#recharge-te').css('min-height', total_height);
  $(window).resize(function(){
    var window_height = $(window).height();
    var headeheight = $('header').outerHeight();
    var footeheight = $('footer').height();
    var sub_total = headeheight + footeheight;
    var total_height = window_height - sub_total;
    $('#recharge-te').css('min-height', total_height);
  });

  $('.product_slider').slick({
    dots: true,
    infinite: true,    
    slidesToShow: 2,     
    responsive: [      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows:false

        }
      },{
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  $('.upsellcollection-slider').slick({
    dots: true,
    infinite: false,    
    slidesToShow: 4,     
    responsive: [      
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3         
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          arrows:false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows:false
        }
      }
    ]
  });

  if($(window).width() < 871){
    $('.tt-product-single-img').slick({  
      slidesToShow: 1,
      arrows:false
    });
  }

  setTimeout(function(){ 
    $('.tt-carousel-products-js').slick('unslick')
    $('.tt-carousel-products-js').slick({
      dots: true,
      infinite: false,
      slidesToShow: 4,
      responsive: [      
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 790,
          settings: {
            slidesToShow: 2            
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            arrows:false
          }
        }
      ]
    });
  }, 2000);

  $('.nav-link').on('click', function(){

    var slider_div = $($(this).attr('href')).children();
    setTimeout(function(){    
      $(slider_div).slick('unslick')
      $(slider_div).slick({
        dots: true,
        infinite: false,
        arrows:true,
        slidesToShow: 4,
        responsive: [      
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 790,
            settings: {
              slidesToShow: 2              

            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              arrows:false
            }
          }
        ]
      });
    }, 500);
  });

  // Accordion - JavaScript
  $('.contentBx').on('click', function(){
    $('.contentBx').removeClass('active');
    $(this).addClass('active')
  });

  //Slick_Slider - Client Sys
  $('.one-time').slick({
    infinite: true,
    arrows: false,
    slidesToShow:4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 870,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }]
  });

  //Banner button 
  $(".down-arrow").click(function(event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: "+=650px" }, 1500);
  });

  // login popup
  $(".login-pop-up").on("click", function () {
    var modal = $(this).data("modal");
    $(modal).show();
    $('body').toggleClass('model_open');
  });
  $('.popup_close ').click(function () {
    $('.modal').hide();
    $('body').removeClass('model_open');
  });
  $(".modal").on("click", function (e) {
    var className = e.target.className;
    if (className === "modal") {
      $(this).closest(".modal").hide();
      $('body').removeClass('model_open');
    }
  });

  $('.customer_popup_link').on('click',function(){    
    var data_id = $(this).data('id');
    $(this).parent().parent().parent().hide();
    if(data_id == 'regiater'){ 
      $(this).parent().parent().parent().next().show();

    }else {
      $(this).parent().parent().parent().prev().show();
    }
  });

  $('.side-bar-menu .mmpanel  .mega-menu li').each(function(){
    var img_class = $(this).children().text().toLowerCase();
    $(this).children().addClass(img_class+'_img');
  });

  // password vidiblity toggle login
  $('.login-psswd').on('click', function() {
    if ($('.input-psswd').attr('psswd-shown') == 'false') {
      $('.input-psswd').removeAttr('type');
      $('.input-psswd').attr('type', 'text');
      $('.input-psswd').removeAttr('psswd-shown');
      $('.input-psswd').attr('psswd-shown', 'true');
    }else {
      $('.input-psswd').removeAttr('type');
      $('.input-psswd').attr('type', 'password');
      $('.input-psswd').removeAttr('psswd-shown');
      $('.input-psswd').attr('psswd-shown', 'false');
    }
  });

  // password vidiblity toggle Register
  $('.register-psswd').on('click', function() {
    if ($('.reg-input-psswd').attr('psswd-shown') == 'false') {
      $('.reg-input-psswd').removeAttr('type');
      $('.reg-input-psswd').attr('type', 'text');
      $('.reg-input-psswd').removeAttr('psswd-shown');
      $('.reg-input-psswd').attr('psswd-shown', 'true');
    }else {
      $('.reg-input-psswd').removeAttr('type');
      $('.reg-input-psswd').attr('type', 'password');
      $('.reg-input-psswd').removeAttr('psswd-shown');
      $('.reg-input-psswd').attr('psswd-shown', 'false');
    }
  });

  $('.mm-next-level').on('click',function(){
    var l_text = $(this).text();
    $('.mm-prev-level').text(l_text);
  });

  // dropdown close
  $('.login-close-btn').on('click', function() {
    $('.login-popup-open').css('display','none');
    $('.tt-account').removeClass('active');
    $('body').removeClass('tt-popup-dropdown');    
  });

  var header_height = $('.tt-mobile-header').outerHeight();
  var window_height = $(window).height() - header_height;
  $('.page404').css('min-height',window_height);
  $(window).resize(function(){
    var header_height = $('.tt-mobile-header').outerHeight();
    var window_height = $(window).height() - header_height;
    $('.page404').css('min-height',window_height);
  });

  $('.tt-search-input').keyup(function(){  
    var term = $(this).val(),      
        item_title = $('#search_item_title').val().toLowerCase(),
        item_array = item_title.split(','),
        search_val = '';
    $.each(item_array, function(index, value){           
      if(term.length > 2){  
        if( value.includes(term) ){             
          var term_val =  value.split(' ');   
          $.each(term_val, function(index, t_value){					
            if( t_value.includes(term) ){             
              if(t_value.substr(0, 3) == term.substr(0, 3)){
                search_val = t_value;
              }
            }
          });
          return false; // breaks
        }
      }
    });    
    if (search_val == ''){ 
      $(this).next('.tt-search-value').text(term);
    }else{       
      $(this).next('.tt-search-value').text(search_val);         	       
    }   
    if($('.search-results').children().length > 0){
      $('.tt-mobile-header .tt-search .tt-dropdown-menu .search_btn').addClass('show_btn');
    }else{
      $('.tt-mobile-header .tt-search .tt-dropdown-menu .search_btn').removeClass('show_btn');
    }
  });


  $('.user_logout svg').on("click", function (e) {
    $('.user_account').slideToggle();
    $('.search-bar').hide(); 
    e.preventDefault();
    e.stopPropagation();
  });

  $('.user_account').on("click", function (e) {
    e.stopPropagation();
  });

  $(document).on('click',function(){    
    $('.user_account').hide();   
    if($('.tt-account.tt-dropdown-obj').hasClass('active')){
      $('body').addClass('tt-popup-dropdown'); 
    }else{
      $('body').removeClass('tt-popup-dropdown'); 
    }
  }); 

  $('.cart-order-summery').on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass('toggle_show');
  });  


  $("ul.tabs li").click(function() {	      
    var activeTab = $(this).attr("rel");
    $(".tab_content").removeClass("active_content");	
    $("#"+activeTab).addClass("active_content");
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");	  
  });

  if($('.upsellcollection-slider .slick-slide ').length < 4){
    $('.upsellcollection-slider').addClass('slide-center');
  }

  $('.image-desktop-blocks .img-text-block img').css('height',$('.image-desktop-blocks-height img').height());
  $('.mobile_image-blocks .img-text-block img').css('height',$('.mobile_image-blocks .image-blocks-height img').height());

  
  $('.Cartoverlay').on("click", function () {
   $( ".js-drawer-close" ).trigger('click');
  });
  
  $('.cart__section form').css('height',$(window).height());
  $(window).resize(function(){
    $('.cart__section form').css('height',$(window).height());
  });
  
  var returnedUserR = sessionStorage.getItem("returneduser");  
  if (!returnedUserR) {
    $('#shpflt-regionalModal').css('display','flex');
    $('.shpflt-closeregional').on('click',function(e){
       e.preventDefault();
    e.stopPropagation();  
      $('#shpflt-regionalModal').hide();
      sessionStorage.setItem("returneduser", "returned");
    });
    
    $('.shpflt-regional-popup,.admin-bar,#cookiesModal,.needsclick[formtype="POPUP"]').on("click", function (e) {
      e.stopPropagation();
    });
    $(document).on("click", function () {
      $('#shpflt-regionalModal').hide();
      sessionStorage.setItem("returneduser", "returned");
    });
    
  }

  $('.subscription-dropdown').on('click',function(){
   $(this).toggleClass('subscription-active');
  });
  
  if( $('#rc_container').length == 0 ){
   $('.subscription-dropdown').hide();
  }
 
  $(document).on('change', '.cart__note .switch input', function() {  
     if ($(this).is(':checked')) {
      $(this).parents('.cart__note').find('.form-default').show();
       localStorage.setItem("note_checked", "checked");
     }else{
     $(this).parents('.cart__note').find('.form-default').hide();
     }
  }); 

  if($('body').hasClass('pagecart')){
    if(localStorage.getItem("note_checked") == "checked"){
      $('.cart__note .switch input').prop('checked','true');
      $('.cart__note').find('.form-default').show();
      localStorage.setItem("note_checked", "");
    }
  }

  $('.tt-newsletter .form-control').keyup(function() {   
    if($(this).val().length > 0 ){
      $(this).parent().addClass('focus');
    }else{
      $(this).parent().removeClass('focus');
    }
  });
  setTimeout(function(){
  
    $('.tt-newsletter form.needsclick input[type=email]').keyup(function() {   
      if($(this).val().length > 0 ){
        $(this).parents('form.needsclick').addClass('focus');
      }else{
        $(this).parents('form.needsclick').removeClass('focus');
      }
    }); 

    $(".tt-newsletter form.needsclick input[type=email]").hover(function(){ 
      $(this).parents('form.needsclick').addClass('hover');
    }, function(){
      $(this).parents('form.needsclick').removeClass('hover');
    });
  }, 3000);
  
});


/* $(document).ready(function() { 
  $('.videomodalbox-main , .videomodalbox-icon').click(function(){
   	//alert("y"); 
    $('.videomodalbox-main , .videomodalbox-icon').hide();
    //$("#iframe").load(location.href + " #iframe");
    $('.video-wrapper').css("display", "block");
   // 
    
  });
 });*/

// Modal de información de envío
$(document).ready(function() {
  // Abrir modal
  $(document).on('click', '[data-shipping-modal-trigger]', function(e) {
    e.preventDefault();
    var modal = $('#modalDrawerShippingInfo');
    var drawerContent = $('.product-drawer-content');
    
    // Hacer scroll hasta arriba del drawer content
    if (drawerContent.length) {
      drawerContent.scrollTop(0);
    }
    
    drawerContent.addClass('shipping-modal-open');
    modal.css('display', 'flex');
    setTimeout(function() {
      modal.addClass('show');
    }, 10);
  });

  // Cerrar modal con botón
  $(document).on('click', '.shipping-modal-close', function(e) {
    e.preventDefault();
    closeShippingModal();
  });

  // Cerrar modal al hacer click en el overlay
  $(document).on('click', '.shipping-modal-overlay', function(e) {
    if ($(e.target).hasClass('shipping-modal-overlay')) {
      closeShippingModal();
    }
  });

  // Cerrar modal con tecla ESC
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $('#modalDrawerShippingInfo').hasClass('show')) {
      closeShippingModal();
    }
  });

  function closeShippingModal() {
    var modal = $('#modalDrawerShippingInfo');
    modal.removeClass('show');
    $('.product-drawer-content').removeClass('shipping-modal-open');
    setTimeout(function() {
      modal.css('display', 'none');
    }, 300);
  }

  // Quitar la clase cuando se cierre el drawer
  $(document).on('click', '.product-drawer-close, .product-drawer-overlay', function() {
    $('.product-drawer-content').removeClass('shipping-modal-open');
    // También cerrar el modal si está abierto
    if ($('#modalDrawerShippingInfo').hasClass('show')) {
      closeShippingModal();
    }
  });

  // Observar cuando el drawer se cierra (cuando se quita la clase is-open)
  var drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        var drawer = $('#product-drawer');
        if (!drawer.hasClass('is-open')) {
          $('.product-drawer-content').removeClass('shipping-modal-open');
          // También cerrar el modal si está abierto
          if ($('#modalDrawerShippingInfo').hasClass('show')) {
            closeShippingModal();
          }
        }
      }
    });
  });

  var drawerElement = document.getElementById('product-drawer');
  if (drawerElement) {
    drawerObserver.observe(drawerElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});


// Zapiet
// a.READY = "zapieteats:ready",
// a.LOADING_SETTINGS = "zapieteats:settings:loading",
// a.SETTINGS_LOADED = "zapieteats:settings:loaded",
// a.LOADING_RESTAURANTS = "zapieteats:restaurants:loading",
// a.LOADED_RESTAURANTS = "zapieteats:restaurants:loaded",
// a.LANGUAGE_CHANGED = "zapieteats:language:changed",
// a.RESTAURANT_CHANGED = "zapieteats:restaurant:changed",
// a.MENU_CHANGED = "zapieteats:menu:changed",
// a.DELIVERY_OPTION_CHANGED = "zapieteats:deliveryoption:changed",
// a.MODAL_OPENED = "zapieteats:modal:opened",
// a.MODAL_CLOSED = "zapieteats:modal:closed",


document.addEventListener("zapieteats:settings:loaded", function(event) {
  console.log(event);
  const instance = window.ZapietEats;
  // Defensive: in some flows the event fires before window.ZapietEats is
  // assigned, or after it has been torn down. Bail out gracefully instead of
  // throwing "Cannot read properties of undefined (reading 'getSelectedDate')".
  if (!instance || typeof instance.getSelectedDate !== 'function') {
    return;
  }
  const selectedDate = new Date(instance.getSelectedDate());

  // Verificar si la opción de delivery es "delivery" y ejecutar reemplazo
  // NO ejecutar si es "pickup"
  try {
    const deliveryOption = instance.getDeliveryOption();
    if (deliveryOption === 'pickup') {
      console.log('Opción de pickup detectada - NO se reemplazarán los textos');
      return;
    }
    if (deliveryOption === 'delivery') {
      console.log('Opción de delivery detectada, ejecutando reemplazo de textos');
      // Ejecutar después de un pequeño delay para asegurar que el DOM esté listo
      setTimeout(function() {
        if (window.replaceTimeTexts) {
          window.replaceTimeTexts();
        }
      }, 300);
      setTimeout(function() {
        if (window.replaceTimeTexts) {
          window.replaceTimeTexts();
        }
      }, 800);
    }
  } catch (e) {
    console.log('Error al obtener delivery option:', e);
  }


});


$(document).on('click', '#shopify-section-product-template .js-go-cart-add-to-cart', function(e) {
  // [Flujo Madreamiga] Si el usuario eligió "Ver menú" en el pop-up de bienvenida,
  // no interrumpir con el modal de Zapiet — dejar pasar el click al form submit nativo.
  if (window.shpfltFlowState && window.shpfltFlowState.isBrowseMode()) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  if (window.ZapietEats && typeof window.ZapietEats.openModal === 'function') {
    ZapietEats.openModal();
    document.body.classList.add('zapiet-modal-open');
  }
});

// Observer to detect clicks on primary Continue button and capture HTML structure state
(function() {
  let continueButtonObserver = null;

  // Function to capture HTML structure state
  function captureHTMLStructureState() {
    const modal = document.getElementById('ZapietEats-WidgetModal');
    if (!modal) return null;

    const state = {
      timestamp: new Date().toISOString(),
      modal: {
        id: modal.id,
        classes: modal.className,
        visible: modal.offsetParent !== null
      },
      deliveryOptions: null,
      selectedLocation: null,
      datePicker: null,
      buttons: []
    };

    // Capture delivery options
    const deliveryOptions = modal.querySelector('.ZapietEats-DeliveryOptions');
    if (deliveryOptions) {
      const pickupBtn = deliveryOptions.querySelector('#pickup');
      const deliveryBtn = deliveryOptions.querySelector('#delivery');
      
      state.deliveryOptions = {
        pickup: {
          id: pickupBtn?.id || null,
          selected: pickupBtn?.getAttribute('aria-selected') === 'true',
          classes: pickupBtn?.className || null,
          active: pickupBtn?.classList.contains('ZapietEats-DeliveryOption--active') || false
        },
        delivery: {
          id: deliveryBtn?.id || null,
          selected: deliveryBtn?.getAttribute('aria-selected') === 'true',
          classes: deliveryBtn?.className || null,
          active: deliveryBtn?.classList.contains('ZapietEats-DeliveryOption--active') || false
        }
      };
    }

    // Capture selected location
    const selectedLocation = modal.querySelector('.ZapietSelectedLocation');
    if (selectedLocation) {
      state.selectedLocation = {
        classes: selectedLocation.className,
        textContent: selectedLocation.textContent?.trim() || null,
        innerHTML: selectedLocation.innerHTML
      };
    }

    // Capture date picker
    const datePicker = modal.querySelector('.ZapietDatePicker');
    if (datePicker) {
      state.datePicker = {
        classes: datePicker.className,
        textContent: datePicker.textContent?.trim() || null,
        innerHTML: datePicker.innerHTML
      };
    }

    // Capture all buttons in the action section
    const actionButtons = modal.querySelectorAll('.ZapietStack .ZapietButton');
    actionButtons.forEach((btn, index) => {
      state.buttons.push({
        index: index,
        text: btn.textContent?.trim() || null,
        classes: btn.className,
        isPrimary: btn.classList.contains('ZapietButton--primary'),
        id: btn.id || null
      });
    });

    return state;
  }

  // Function to check if element is the continue button
  function isContinueButton(element) {
    if (!element) return false;
    // Check if it's a button with primary class
    if (element.classList && 
        element.classList.contains('ZapietButton') && 
        element.classList.contains('ZapietButton--primary')) {
      const text = element.textContent?.trim();
      if (text === 'Continuar') {
        return true;
      }
    }
    // Also check parent elements (in case click is on child element)
    let current = element;
    for (let i = 0; i < 3 && current; i++) {
      if (current.classList && 
          current.classList.contains('ZapietButton') && 
          current.classList.contains('ZapietButton--primary')) {
        const text = current.textContent?.trim();
        if (text === 'Continuar') {
          return true;
        }
      }
      current = current.parentElement;
    }
    return false;
  }

  // Use event delegation with capture phase to catch clicks
  function handleClick(e) {
    if (isContinueButton(e.target)) {
      console.log('Continue button clicked detected!');
      const state = captureHTMLStructureState();
      console.log('Continue button clicked! HTML Structure State:', state);
      
      // You can also dispatch a custom event with the state
      const event = new CustomEvent('zapietContinueButtonClicked', {
        detail: state
      });
      document.dispatchEvent(event);
    }
  }

  // Main observer to watch for modal appearance
  function startObserving() {
    // Use event delegation on document with capture phase
    // This ensures we catch the event even if it's stopped elsewhere
    document.addEventListener('click', handleClick, true);
    console.log('Continue button observer: Event delegation attached (capture phase)');

    // Also try direct attachment when button appears
    function tryAttachHandler() {
      const continueButton = document.querySelector('.ZapietButton.ZapietButton--primary');
      if (continueButton) {
        const text = continueButton.textContent?.trim();
        if (text === 'Continuar') {
          // Add another listener directly on the button as backup
          continueButton.addEventListener('click', function(e) {
            console.log('Continue button direct click handler fired!');
            const state = captureHTMLStructureState();
            console.log('Continue button clicked! HTML Structure State:', state);
            
            const event = new CustomEvent('zapietContinueButtonClicked', {
              detail: state
            });
            document.dispatchEvent(event);
          }, { once: false, capture: true });
          
          console.log('Continue button observer: Direct handler attached to button');
        }
      }
    }

    // Check if modal already exists
    const modal = document.getElementById('ZapietEats-WidgetModal');
    if (modal) {
      setTimeout(tryAttachHandler, 100);
    }

    // Create observer to watch for modal and button appearance
    continueButtonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // Check if modal was added or changed
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the modal itself was added
              if (node.id === 'ZapietEats-WidgetModal' || 
                  (node.querySelector && node.querySelector('#ZapietEats-WidgetModal'))) {
                setTimeout(tryAttachHandler, 200);
              }
              // Check if continue button was added
              if (isContinueButton(node)) {
                setTimeout(tryAttachHandler, 200);
              }
            }
          });
        }
        
        // Check if modal visibility changed (attributes)
        if (mutation.type === 'attributes') {
          const modal = document.getElementById('ZapietEats-WidgetModal');
          if (modal && modal.offsetParent !== null) {
            setTimeout(tryAttachHandler, 200);
          }
        }
      });
    });

    // Observe document body for modal additions
    continueButtonObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    // Also observe the modal directly if it exists
    if (modal) {
      continueButtonObserver.observe(modal, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    console.log('Continue button observer: Started observing');
  }

  // Start observing when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // Also listen for Zapiet modal events
  document.addEventListener('zapieteats:modal:opened', function() {
    setTimeout(function() {
      const continueButton = document.querySelector('.ZapietButton.ZapietButton--primary');
      if (continueButton && continueButton.textContent.trim() === 'Continuar') {
        continueButton.addEventListener('click', function(e) {
          console.log('Continue button clicked via Zapiet event!');
          const state = captureHTMLStructureState();
          console.log('Continue button clicked! HTML Structure State:', state);
          
          const event = new CustomEvent('zapietContinueButtonClicked', {
            detail: state
          });
          document.dispatchEvent(event);
        }, { once: false, capture: true });
        console.log('Continue button observer: Handler attached via Zapiet event');
      }
    }, 300);
  });
})();

// Observer para reemplazar textos de hora cuando el botón de delivery está activo
(function() {
  // Flag de debug (cambiar a false en producción)
  const DEBUG = false;
  
  // Función helper para logging condicional
  function debugLog() {
    if (DEBUG && console && console.log) {
      console.log.apply(console, arguments);
    }
  }
  
  // Variables para gestión de recursos (evitar memory leaks)
  let widgetObserver = null;
  let intervalId = null;
  let eventListeners = [];
  let isObserverInitialized = false;
  let retryCount = 0;
  const MAX_RETRIES = 20; // Límite de reintentos (20 * 500ms = 10 segundos máximo)
  
  // Cache de selectores DOM
  let widgetCache = null;
  let topBarCache = null;
  let cacheTimestamp = 0;
  const CACHE_TTL = 1000; // Cache válido por 1 segundo
  
  // Función para obtener elementos con caché
  function getWidgetElements() {
    const now = Date.now();
    if (widgetCache && topBarCache && (now - cacheTimestamp) < CACHE_TTL) {
      return { widget: widgetCache, topBar: topBarCache };
    }
    
    widgetCache = document.getElementById('ZapietEats-Widget') || 
                  document.querySelector('#ZapietEats-Widget') ||
                  document.getElementById('ZapietEats-WidgetModal') ||
                  document.querySelector('#ZapietEats-WidgetModal');
    
    topBarCache = document.getElementById('ZapietEats-TopBar') ||
                  document.querySelector('#ZapietEats-TopBar');
    
    cacheTimestamp = now;
    return { widget: widgetCache, topBar: topBarCache };
  }
  
  // Debounce para replaceTimeTexts
  let replaceTimeoutId = null;
  function debouncedReplaceTimeTexts(delay) {
    if (replaceTimeoutId) {
      clearTimeout(replaceTimeoutId);
    }
    replaceTimeoutId = setTimeout(function() {
      replaceTimeTexts();
      replaceTimeoutId = null;
    }, delay || 200);
  }
  
  function replaceTimeTexts() {
    // Invalidar caché para obtener elementos frescos
    cacheTimestamp = 0;
    const { widget, topBar } = getWidgetElements();
    
    // Si no hay widget ni TopBar, no hacer nada
    if (!widget && !topBar) {
      debugLog('ZapietEats-Widget, ZapietEats-WidgetModal o ZapietEats-TopBar no encontrado');
      return;
    }
    
    // Crear un contenedor virtual que incluya widget y TopBar para procesar ambos
    const containersToProcess = [];
    if (widget) containersToProcess.push(widget);
    if (topBar) containersToProcess.push(topBar);

    // Verificar si el botón de pickup está seleccionado - si está activo, NO reemplazar
    const pickupButton = (widget && widget.querySelector('button#pickup[role="tab"]')) || 
                        (widget && widget.querySelector('button#pickup')) ||
                        document.querySelector('button#pickup[role="tab"][aria-controls="pickup-tab"]') ||
                        document.querySelector('button#pickup[role="tab"]') ||
                        document.querySelector('button#pickup');
    
    if (pickupButton) {
      const pickupIsSelected = pickupButton.getAttribute('aria-selected') === 'true';
      const pickupHasActiveClass = pickupButton.classList.contains('ZapietEats-DeliveryOption--active');
      
      if (pickupIsSelected || pickupHasActiveClass) {
        debugLog('Botón pickup está activo - NO se reemplazarán los textos');
        return;
      }
    }
    
    // Verificar si el botón de delivery está seleccionado (búsqueda más flexible)
    // Buscar primero en el widget/modal, luego en todo el documento
    const deliveryButton = (widget && widget.querySelector('button#delivery[role="tab"]')) || 
                           (widget && widget.querySelector('button#delivery')) ||
                           document.querySelector('button#delivery[role="tab"][aria-controls="delivery-tab"]') ||
                           document.querySelector('button#delivery[role="tab"]') ||
                           document.querySelector('button#delivery');
    
    // Verificar también si existe el elemento ZapietEats-Details__title con "Detalles de envio"
    // Esto indica que estamos en la pantalla de delivery aunque no haya botón visible
    // NO ejecutar si el título es "Detalles de Recogida"
    const detailsTitle = (widget && widget.querySelector('.ZapietEats-Details__title')) ||
                         document.querySelector('.ZapietEats-Details__title');
    
    // Si el título es "Detalles de Recogida", no ejecutar reemplazo
    if (detailsTitle && detailsTitle.textContent && 
        detailsTitle.textContent.trim().includes('Detalles de Recogida')) {
      debugLog('Título "Detalles de Recogida" detectado - NO se reemplazarán los textos');
      return;
    }
    
    const hasDetailsTitle = detailsTitle && 
                           detailsTitle.textContent && 
                           detailsTitle.textContent.trim().includes('Detalles de envio');
    
    // Verificar si existe el TopBar con el botón "Envio" (indica que estamos en modo delivery)
    const topBarEnvioButton = topBar && topBar.querySelector('.ZapietEats-TopBar-Button');
    const hasTopBarEnvio = topBarEnvioButton && 
                          topBarEnvioButton.textContent && 
                          topBarEnvioButton.textContent.trim().includes('Envio');
    
    let shouldReplace = false;
    
    if (deliveryButton) {
      const isSelected = deliveryButton.getAttribute('aria-selected') === 'true';
      const hasActiveClass = deliveryButton.classList.contains('ZapietEats-DeliveryOption--active');
      
      if (isSelected || hasActiveClass) {
        shouldReplace = true;
        debugLog('Botón delivery está activo');
      } else {
        debugLog('Botón delivery no está activo');
      }
    } else {
      debugLog('Botón delivery no encontrado');
    }
    
    // Si no hay botón activo pero existe el título "Detalles de envio", también ejecutar
    if (!shouldReplace && hasDetailsTitle) {
      shouldReplace = true;
      debugLog('Elemento "Detalles de envio" encontrado, ejecutando reemplazo');
    }
    
    // Si existe el TopBar con "Envio", también ejecutar (indica modo delivery)
    if (!shouldReplace && hasTopBarEnvio) {
      shouldReplace = true;
      debugLog('TopBar con "Envio" encontrado, ejecutando reemplazo');
    }
    
    if (!shouldReplace) {
      debugLog('No se cumplen las condiciones para reemplazar');
      return;
    }

    debugLog('Reemplazando textos en widget/modal/TopBar...');

    // Patrón: captura cualquier texto antes de "a las HH:MM AM/PM" y lo reemplaza por "a lo largo del día"
    // Ejemplos:
    // "Viernes, 28th Nov a las 9:00 AM" -> "Viernes, 28th Nov a lo largo del día"
    // "Vie, 28th Nov a las 9:00 AM" -> "Vie, 28th Nov a lo largo del día"
    // "24 de diciembre a las 16:00" -> "24 de diciembre a lo largo del día"
    const patterns = [
      // Patrón principal: captura todo antes de "a las HH:MM" seguido opcionalmente de AM/PM
      // Usa non-greedy match (.+?) para capturar solo hasta "a las"
      /(.+?)\s+a\s+las\s+\d{1,2}:\d{2}(\s*(AM|PM))?/gi
    ];
    
    let replacedCount = 0;

    // Procesar cada contenedor (widget, modal, TopBar)
    containersToProcess.forEach(function(container, containerIndex) {
      const containerName = container.id || container.className || 'container-' + containerIndex;
      debugLog('Procesando contenedor:', containerName);
      
      // Obtener todo el texto del contenedor para debugging
      const containerFullText = container.textContent || container.innerText || '';
      if (containerFullText.length > 0) {
        debugLog('Texto completo del contenedor (primeros 300 caracteres):', containerFullText.substring(0, 300));
      }
      
      // Buscar si hay algún texto que contenga "a las" seguido de hora
      const testPattern = /a\s+las\s+\d{1,2}:\d{2}/gi;
      const matches = containerFullText.match(testPattern);
      if (matches && matches.length > 0) {
        debugLog('Coincidencias encontradas con "a las HH:MM" en', containerName + ':', matches);
      }

      // Método 1: Procesar todos los nodos de texto dentro del contenedor
      const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      let textNode;
      let nodeCount = 0;
      while (textNode = walker.nextNode()) {
        nodeCount++;
        let originalText = textNode.textContent;
        
        // Solo procesar nodos que tienen contenido significativo
        if (!originalText || originalText.trim().length < 10) continue;
        
        // Verificar si contiene "a las" seguido de hora
        if (!/a\s+las\s+\d{1,2}:\d{2}/i.test(originalText)) continue;
        
        debugLog('Nodo encontrado con patrón:', originalText.trim().substring(0, 80));
        
        let newText = originalText;
        
        // Aplicar todos los patrones
        patterns.forEach((pattern, index) => {
          // Crear nueva instancia del regex para evitar problemas con lastIndex
          const regex = new RegExp(pattern.source, pattern.flags);
          const beforeReplace = newText;
          
          // Reemplazar "a las HH:MM AM/PM" o "a las HH:MM" por "a lo largo del día"
          // El $1 captura todo lo anterior a "a las"
          newText = newText.replace(regex, function(match, p1, p2) {
            debugLog('Match encontrado:', match);
            debugLog('p1 (texto anterior):', p1);
            debugLog('p2 (AM/PM):', p2);
            // p1 es el texto antes de "a las", p2 es el AM/PM opcional
            const result = p1.trim() + ' a lo largo del día';
            debugLog('Resultado del reemplazo:', result);
            return result;
          });
          if (newText !== beforeReplace) {
            debugLog(`✓ Patrón ${index} funcionó:`, beforeReplace.trim().substring(0, 70), '->', newText.trim().substring(0, 70));
          } else {
            debugLog(`⚠ Patrón ${index} no hizo cambios. Texto:`, beforeReplace.trim());
          }
        });
        
        if (newText !== originalText) {
          textNode.textContent = newText;
          replacedCount++;
          debugLog('✓ Reemplazado (texto):', originalText.trim().substring(0, 60), '->', newText.trim().substring(0, 60));
        }
      }
      
      debugLog('Nodos de texto procesados en', containerName + ':', nodeCount);

      // Método 2: Buscar y reemplazar en elementos específicos que contengan el texto
      // Esto es útil para elementos como ZapietEats-Details__SearchMenu__item__text o ZapietEats-TopBar-SecondaryText
      const textElements = container.querySelectorAll('*');
    textElements.forEach(element => {
      // Solo procesar elementos que tienen texto y no tienen hijos con texto propio
      const elementText = element.textContent || element.innerText || '';
      if (elementText && /a\s+las\s+\d{1,2}:\d{2}/i.test(elementText)) {
        // Verificar que el texto está directamente en este elemento, no en sus hijos
        const directText = Array.from(element.childNodes)
          .filter(node => node.nodeType === Node.TEXT_NODE)
          .map(node => node.textContent)
          .join('');
        
        if (directText && /a\s+las\s+\d{1,2}:\d{2}/i.test(directText)) {
          // El texto está directamente en el elemento
          let newDirectText = directText;
          patterns.forEach((pattern, index) => {
            const regex = new RegExp(pattern.source, pattern.flags);
            newDirectText = newDirectText.replace(regex, function(match, p1, p2) {
              return p1.trim() + ' a lo largo del día';
            });
          });
          
          if (newDirectText !== directText) {
            // Reemplazar el texto directo
            Array.from(element.childNodes)
              .filter(node => node.nodeType === Node.TEXT_NODE)
              .forEach(node => {
                node.textContent = newDirectText;
              });
            replacedCount++;
            debugLog('✓ Reemplazado en elemento directo:', elementText.trim().substring(0, 60));
          }
        } else {
          // El texto está en el innerHTML del elemento
          // Intentar primero con textContent si es posible, sino usar innerHTML con sanitización
          const elementHTML = element.innerHTML;
          if (elementHTML && /a\s+las\s+\d{1,2}:\d{2}/i.test(elementHTML)) {
            // Verificar si podemos usar textContent en lugar de innerHTML
            const textOnly = element.textContent || element.innerText || '';
            if (textOnly && textOnly === elementHTML.replace(/<[^>]*>/g, '')) {
              // El contenido es solo texto, usar textContent es más seguro
              let newText = textOnly;
              patterns.forEach((pattern) => {
                const regex = new RegExp(pattern.source, pattern.flags);
                newText = newText.replace(regex, function(match, p1) {
                  return p1.trim() + ' a lo largo del día';
                });
              });
              if (newText !== textOnly) {
                element.textContent = newText;
                replacedCount++;
                debugLog('✓ Reemplazado usando textContent:', elementText.trim().substring(0, 60));
              }
            } else {
              // Necesitamos usar innerHTML, pero solo reemplazamos texto dentro del contenido
              let newElementHTML = elementHTML;
              patterns.forEach((pattern) => {
                const regex = new RegExp(pattern.source, pattern.flags);
                newElementHTML = newElementHTML.replace(regex, function(match, p1) {
                  // Solo reemplazar si p1 no contiene tags HTML (sanitización básica)
                  if (/<[^>]*>/.test(p1)) {
                    return match; // No reemplazar si contiene HTML
                  }
                  return p1.trim() + ' a lo largo del día';
                });
              });
              
              if (newElementHTML !== elementHTML) {
                element.innerHTML = newElementHTML;
                replacedCount++;
                debugLog('✓ Reemplazado en innerHTML del elemento:', elementText.trim().substring(0, 60));
              }
            }
          }
        }
      }
      });

      // Método 3: Buscar y reemplazar directamente en el innerHTML del contenedor completo como último recurso
      const containerHTML = container.innerHTML;
      if (containerHTML && /a\s+las\s+\d{1,2}:\d{2}/i.test(containerHTML)) {
        debugLog('Intentando reemplazo en HTML completo de', containerName + '...');
        let newHTML = containerHTML;
        
        patterns.forEach((pattern, index) => {
          const regex = new RegExp(pattern.source, pattern.flags);
          const beforeReplace = newHTML;
          // Reemplazar "a las HH:MM AM/PM" o "a las HH:MM" por "a lo largo del día"
          newHTML = newHTML.replace(regex, function(match, p1) {
            // Sanitización: no reemplazar si p1 contiene tags HTML
            if (/<[^>]*>/.test(p1)) {
              return match;
            }
            return p1.trim() + ' a lo largo del día';
          });
          if (newHTML !== beforeReplace) {
            debugLog(`✓ Patrón ${index} funcionó en HTML completo de`, containerName);
            replacedCount++;
          }
        });
        
        if (newHTML !== containerHTML) {
          container.innerHTML = newHTML;
          debugLog('✓ Reemplazo realizado en HTML completo de', containerName);
        }
      }
    }); // Fin del loop de contenedores
    
    debugLog('Total de reemplazos:', replacedCount);
  }

  // Función para limpiar recursos
  function cleanupResources() {
    if (widgetObserver) {
      widgetObserver.disconnect();
      widgetObserver = null;
    }
    
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    
    // Limpiar event listeners
    eventListeners.forEach(function(listener) {
      if (listener.element && listener.handler) {
        listener.element.removeEventListener(listener.event, listener.handler, listener.capture);
      }
    });
    eventListeners = [];
    
    if (replaceTimeoutId) {
      clearTimeout(replaceTimeoutId);
      replaceTimeoutId = null;
    }
    
    isObserverInitialized = false;
    retryCount = 0;
    cacheTimestamp = 0;
  }
  
  // Helper para agregar event listeners con tracking
  function addTrackedEventListener(element, event, handler, capture) {
    if (element && handler) {
      element.addEventListener(event, handler, capture);
      eventListeners.push({
        element: element,
        event: event,
        handler: handler,
        capture: capture || false
      });
    }
  }
  
  // Observer para observar cambios en el widget, modal y TopBar
  function startWidgetObserver() {
    // Evitar múltiples inicializaciones
    if (isObserverInitialized) {
      debugLog('Observer ya inicializado, omitiendo...');
      return;
    }
    
    // Limpiar recursos anteriores si existen
    cleanupResources();
    
    cacheTimestamp = 0; // Invalidar caché
    const { widget, topBar } = getWidgetElements();
    
    // Si no hay widget ni TopBar, intentar de nuevo después de un tiempo (con límite)
    if (!widget && !topBar) {
      retryCount++;
      if (retryCount < MAX_RETRIES) {
        setTimeout(startWidgetObserver, 500);
      } else {
        debugLog('Límite de reintentos alcanzado para encontrar widget');
      }
      return;
    }
    
    // Resetear contador de reintentos cuando encontramos el widget
    retryCount = 0;
    isObserverInitialized = true;

    debugLog('Iniciando observer para ZapietEats-Widget/Modal/TopBar');

    // Ejecutar reemplazo inicial con debounce (en lugar de múltiples setTimeout)
    debouncedReplaceTimeTexts(100);
    debouncedReplaceTimeTexts(500);
    debouncedReplaceTimeTexts(1000);

    // Crear observer para cambios en el widget
    widgetObserver = new MutationObserver(function(mutations) {
      let shouldReplace = false;

      mutations.forEach(function(mutation) {
        // Si cambió el contenido o los atributos
        if (mutation.type === 'childList' || mutation.type === 'attributes' || mutation.type === 'characterData') {
          shouldReplace = true;
        }
      });

      if (shouldReplace) {
        // Invalidar caché cuando hay cambios
        cacheTimestamp = 0;
        // Usar debounce en lugar de múltiples setTimeout
        debouncedReplaceTimeTexts(50);
        debouncedReplaceTimeTexts(200);
      }
    });

    // Observar cambios en el widget/modal (más agresivo)
    if (widget) {
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-selected', 'class', 'style']
      });
    }
    
    // Observar cambios en el TopBar también
    if (topBar) {
      widgetObserver.observe(topBar, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      debugLog('Observando TopBar');
    }

    // También observar cambios específicos en el botón de delivery
    let deliveryButtonRetryCount = 0;
    const MAX_DELIVERY_BUTTON_RETRIES = 10;
    
    function observeDeliveryButton() {
      const deliveryButton = (widget && widget.querySelector('button#delivery[role="tab"]')) || 
                             (widget && widget.querySelector('button#delivery')) ||
                             document.querySelector('button#delivery[role="tab"][aria-controls="delivery-tab"]');
      if (deliveryButton && widgetObserver) {
        widgetObserver.observe(deliveryButton, {
          attributes: true,
          attributeFilter: ['aria-selected', 'class']
        });
        debugLog('Observando botón delivery');
      } else {
        // Intentar de nuevo si no se encuentra (con límite)
        deliveryButtonRetryCount++;
        if (deliveryButtonRetryCount < MAX_DELIVERY_BUTTON_RETRIES) {
          setTimeout(observeDeliveryButton, 500);
        }
      }
    }
    observeDeliveryButton();

    // Observar cuando cambia el botón de delivery (usando eventos de click)
    if (widget) {
      const widgetClickHandler = function(e) {
        const target = e.target.closest('button#delivery') || e.target;
        if (target && (target.id === 'delivery' || target.getAttribute('aria-controls') === 'delivery-tab')) {
          cacheTimestamp = 0; // Invalidar caché
          debouncedReplaceTimeTexts(100);
          debouncedReplaceTimeTexts(300);
          debouncedReplaceTimeTexts(600);
        }
      };
      addTrackedEventListener(widget, 'click', widgetClickHandler, true);
    }
    
    // También observar clicks en el TopBar
    if (topBar) {
      const topBarClickHandler = function(e) {
        cacheTimestamp = 0; // Invalidar caché
        debouncedReplaceTimeTexts(100);
        debouncedReplaceTimeTexts(300);
      };
      addTrackedEventListener(topBar, 'click', topBarClickHandler, true);
    }
  }

  // Iniciar cuando el DOM esté listo
  const domReadyHandler = function() {
    startWidgetObserver();
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domReadyHandler);
    eventListeners.push({
      element: document,
      event: 'DOMContentLoaded',
      handler: domReadyHandler,
      capture: false
    });
  } else {
    startWidgetObserver();
  }

  // También escuchar eventos de Zapiet para cuando se abre el modal
  const modalOpenedHandler = function() {
    debugLog('Modal de Zapiet abierto');
    // Reinicializar observer si es necesario
    if (!isObserverInitialized) {
      setTimeout(startWidgetObserver, 300);
    }
    cacheTimestamp = 0; // Invalidar caché
    debouncedReplaceTimeTexts(500);
    debouncedReplaceTimeTexts(1000);
    debouncedReplaceTimeTexts(1500);
  };
  addTrackedEventListener(document, 'zapieteats:modal:opened', modalOpenedHandler, false);

  // Escuchar cuando cambia la opción de delivery
  const deliveryOptionChangedHandler = function() {
    debugLog('Opción de delivery cambiada');
    cacheTimestamp = 0; // Invalidar caché
    debouncedReplaceTimeTexts(100);
    debouncedReplaceTimeTexts(300);
    debouncedReplaceTimeTexts(600);
  };
  addTrackedEventListener(document, 'zapieteats:deliveryoption:changed', deliveryOptionChangedHandler, false);

  // También ejecutar periódicamente cuando el widget, modal o TopBar está visible
  // Pero solo si están visibles y no hay observer activo
  function startPeriodicCheck() {
    if (intervalId) {
      return; // Ya está corriendo
    }
    
    intervalId = setInterval(function() {
      cacheTimestamp = 0; // Invalidar caché en cada iteración
      const { widget, topBar } = getWidgetElements();
      
      const isWidgetVisible = widget && widget.offsetParent !== null;
      const isTopBarVisible = topBar && topBar.offsetParent !== null;
      
      // Si no hay elementos visibles, limpiar el interval
      if (!isWidgetVisible && !isTopBarVisible) {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        return;
      }
      
      if (isWidgetVisible || isTopBarVisible) {
        // Primero verificar si el botón de pickup está activo - si está activo, NO ejecutar
        const pickupButton = (widget && widget.querySelector('button#pickup[role="tab"]')) || 
                             (widget && widget.querySelector('button#pickup')) ||
                             document.querySelector('button#pickup[role="tab"][aria-controls="pickup-tab"]') ||
                             document.querySelector('button#pickup[role="tab"]') ||
                             document.querySelector('button#pickup');
        
        if (pickupButton) {
          const pickupIsSelected = pickupButton.getAttribute('aria-selected') === 'true';
          const pickupHasActiveClass = pickupButton.classList.contains('ZapietEats-DeliveryOption--active');
          
          if (pickupIsSelected || pickupHasActiveClass) {
            // Pickup está activo, no ejecutar reemplazo
            return;
          }
        }
        
        const deliveryButton = (widget && widget.querySelector('button#delivery[role="tab"]')) || 
                               (widget && widget.querySelector('button#delivery')) ||
                               document.querySelector('button#delivery[role="tab"]') ||
                               document.querySelector('button#delivery');
        
        // Verificar si el botón está activo
        const buttonActive = deliveryButton && 
                            (deliveryButton.getAttribute('aria-selected') === 'true' || 
                             deliveryButton.classList.contains('ZapietEats-DeliveryOption--active'));
        
        // Verificar también si existe el elemento ZapietEats-Details__title con "Detalles de envio"
        // NO ejecutar si el título es "Detalles de Recogida"
        const detailsTitle = (widget && widget.querySelector('.ZapietEats-Details__title')) ||
                             document.querySelector('.ZapietEats-Details__title');
        
        // Si el título es "Detalles de Recogida", no ejecutar reemplazo
        if (detailsTitle && detailsTitle.textContent && 
            detailsTitle.textContent.trim().includes('Detalles de Recogida')) {
          // Recogida está activo, no ejecutar reemplazo
          return;
        }
        
        const hasDetailsTitle = detailsTitle && 
                               detailsTitle.textContent && 
                               detailsTitle.textContent.trim().includes('Detalles de envio');
        
        // Verificar si existe el TopBar con el botón "Envio"
        const topBarEnvioButton = topBar && topBar.querySelector('.ZapietEats-TopBar-Button');
        const hasTopBarEnvio = topBarEnvioButton && 
                              topBarEnvioButton.textContent && 
                              topBarEnvioButton.textContent.trim().includes('Envio');
        
        // Ejecutar si el botón está activo O si existe el título "Detalles de envio" O si existe el TopBar con "Envio"
        if (buttonActive || hasDetailsTitle || hasTopBarEnvio) {
          replaceTimeTexts();
        }
      }
    }, 2000);
  }
  
  // Iniciar el check periódico después de un delay inicial
  setTimeout(startPeriodicCheck, 3000);
  
  // Exponer la función globalmente para que pueda ser llamada desde otros listeners
  window.replaceTimeTexts = replaceTimeTexts;
  
  // Exponer función de limpieza para testing o cleanup manual
  window.cleanupZapietTimeReplacement = cleanupResources;
})();

// ============================================================================
// Gestión de intervalos de fechas para Navidad y otros períodos
// ============================================================================
(function() {
  // Flag de debug (cambiar a false en producción)
  const DEBUG_DATE_INTERVALS = false;
  
  // Función helper para logging condicional
  function debugLog() {
    if (DEBUG_DATE_INTERVALS && console && console.log) {
      console.log.apply(console, arguments);
    }
  }
  
  // Helper function to parse DD-MM-YYYY HH:mm:ss format
  function parseDateString(dateString) {
    if (!dateString || typeof dateString !== 'string') {
      return null;
    }
    
    try {
      // Validar formato básico: debe contener al menos DD-MM-YYYY
      const datePattern = /^(\d{1,2})-(\d{1,2})-(\d{4})(\s+(\d{1,2}):(\d{1,2}):(\d{1,2}))?$/;
      if (!datePattern.test(dateString.trim())) {
        debugLog('Formato de fecha inválido:', dateString);
        return null;
      }
      
      // Convert DD-MM-YYYY HH:mm:ss to YYYY-MM-DDTHH:mm:ss format
      const parts = dateString.trim().split(' ');
      const datePart = parts[0].split('-');
      
      // Validar que tenemos día, mes y año
      if (datePart.length !== 3) {
        debugLog('Formato de fecha incompleto:', dateString);
        return null;
      }
      
      const day = parseInt(datePart[0], 10);
      const month = parseInt(datePart[1], 10);
      const year = parseInt(datePart[2], 10);
      
      // Validar rangos básicos
      if (isNaN(day) || isNaN(month) || isNaN(year) || 
          day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
        debugLog('Valores de fecha fuera de rango:', dateString);
        return null;
      }
      
      const timePart = parts[1] || '00:00:00';
            // Reorder: DD-MM-YYYY -> YYYY-MM-DD
                  const isoString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${timePart}`;
                        const parsedDate = new Date(isoString);
      
      // Validar que la fecha es válida
      if (isNaN(parsedDate.getTime())) {
        debugLog('Fecha inválida después del parseo:', isoString);
        return null;
      }
      
      return parsedDate;
    } catch (error) {
      debugLog('Error al parsear fecha:', dateString, error);
      return null;
    }
  }

  // Definición de intervalos de fechas
  // Temporada 2026-27, según la hoja "HORARIO ROSCONES WEB 2026/2027":
  // servicio de roscones del 26/11/2026 al 31/01/2027.
  // Del 2 al 7/01 solo se venden los productos etiquetados dias-fuertes-*
  // (roscón grande, botella de chocolate, mangas), así que no se usa
  // solo_navidad (ocultaba todo menos roscones).
  // El primer intervalo que encaja con la fecha elegida en Zapiet gana.
  const intervals = {
    no_navidad: {
      maxDate: '25-11-2026 23:59:59'
    },
    antes_navidad: {
      minDate: '26-11-2026 00:00:00',
      maxDate: '31-12-2026 23:59:59'
    },
    // Días de alta demanda del 2 al 7 de enero de 2027.
    // La visibilidad de cada producto depende de sus tags (ver custom.css y data-df en las tarjetas).
    // Qué días hay envío lo decide Zapiet (fechas por producto/ubicación), no el tema.
    dias_fuertes: {
      minDate: '02-01-2027 00:00:00',
      maxDate: '07-01-2027 23:59:59'
    },
    despues_navidad: {
      minDate: '01-01-2027 00:00:00',
      maxDate: '31-01-2027 23:59:59'
    },
    resto_del_ano: {
      minDate: '01-02-2027 00:00:00',
      maxDate: '06-02-2027 23:59:59'
    },
    san_valentin: {
      minDate: '07-02-2027 00:00:00',
      maxDate: '21-02-2027 23:59:59'
    },
    resto_del_ano_2: {
      minDate: '22-02-2027 00:00:00',
      maxDate: '09-03-2027 23:59:59'
    },
    dia_de_padre: {
      minDate: '10-03-2027 00:00:00',
      maxDate: '21-03-2027 23:59:59'
    },
    dia_de_padre_2: {
      minDate: '22-03-2027 00:00:00',
      maxDate: '31-03-2027 23:59:59'
    },
    resto_del_ano_3: {
      minDate: '01-04-2027 00:00:00',
      maxDate: '31-12-2027 23:59:59'
    }
  };
  
  // Función para asignar el intervalo correspondiente a la fecha seleccionada
  function assignDateInterval() {
    try {
      // Validar que ZapietEats existe
      if (!window.ZapietEats || typeof window.ZapietEats !== 'object') {
        debugLog('ZapietEats no está disponible');
        return;
      }
      
      const instance = window.ZapietEats;
      
      // Validar que getSelectedDate existe y es una función
      if (!instance.getSelectedDate || typeof instance.getSelectedDate !== 'function') {
        debugLog('getSelectedDate no está disponible');
        return;
      }
      
      const selectedDateValue = instance.getSelectedDate();
      
      // Validar que getSelectedDate retornó un valor válido
      if (!selectedDateValue) {
        debugLog('getSelectedDate retornó un valor vacío');
        return;
      }
      
      const selectedDate = new Date(selectedDateValue);
      
      // Validar que la fecha es válida
      if (isNaN(selectedDate.getTime())) {
        debugLog('Fecha seleccionada inválida:', selectedDateValue);
        return;
      }
    
      for (const interval in intervals) {
        if (!intervals.hasOwnProperty(interval)) {
          continue;
        }
        
        const minDate = intervals[interval].minDate ? parseDateString(intervals[interval].minDate) : null;
        const maxDate = intervals[interval].maxDate ? parseDateString(intervals[interval].maxDate) : null;
        
        // Validar que las fechas fueron parseadas correctamente
        if (intervals[interval].minDate && !minDate) {
          debugLog('Error al parsear minDate para intervalo:', interval, intervals[interval].minDate);
          continue;
        }
        if (intervals[interval].maxDate && !maxDate) {
          debugLog('Error al parsear maxDate para intervalo:', interval, intervals[interval].maxDate);
          continue;
        }
        
        debugLog('Intervalo:', interval, 'minDate:', minDate, 'maxDate:', maxDate);
        
        // Check if selectedDate falls within the interval
        let matches = true;
        if (minDate && selectedDate < minDate) {
          matches = false;
        }
        if (maxDate && selectedDate > maxDate) {
          matches = false;
        }
        if (matches) {
          try {
            document.documentElement.dataset.timeDate = selectedDate.toLocaleDateString();
            document.documentElement.dataset.timeFrame = interval;
            debugLog('Intervalo asignado:', interval);
            break;
          } catch (error) {
            debugLog('Error al asignar dataset:', error);
          }
        }
      }

      // Escribir opción de entrega (pickup / delivery) en el dataset del html.
      // Primero la API de Zapiet (funciona en cualquier página, con el modal
      // cerrado); los botones #delivery / #pickup solo existen con el modal abierto.
      try {
        let deliveryOpt = '';
        if (typeof instance.getDeliveryOption === 'function') {
          const apiOpt = String(instance.getDeliveryOption() || '').toLowerCase();
          if (apiOpt === 'pickup' || apiOpt === 'store_pickup') {
            deliveryOpt = 'pickup';
          } else if (apiOpt.indexOf('deliver') > -1 || apiOpt.indexOf('ship') > -1) {
            deliveryOpt = 'delivery';
          }
        }
        const deliveryBtn = document.querySelector('#delivery');
        const pickupBtn = document.querySelector('#pickup');
        if (deliveryBtn && (deliveryBtn.getAttribute('aria-selected') === 'true' || deliveryBtn.classList.contains('ZapietEats-DeliveryOption--active'))) {
          deliveryOpt = 'delivery';
        } else if (pickupBtn && (pickupBtn.getAttribute('aria-selected') === 'true' || pickupBtn.classList.contains('ZapietEats-DeliveryOption--active'))) {
          deliveryOpt = 'pickup';
        }
        document.documentElement.dataset.deliveryOption = deliveryOpt;
        debugLog('Delivery option asignada:', deliveryOpt);
      } catch (error) {
        debugLog('Error al asignar deliveryOption:', error);
      }

      // Actualizar estado del botón en la ficha de producto (PDP).
      updatePdpButtonState();

    } catch (error) {
      debugLog('Error en assignDateInterval:', error);
    }
  }

  // Actualiza el atributo disabled / aria-disabled del botón de añadir en la PDP
  // según el intervalo activo, el modo de entrega y los tags del producto.
  // Para el catálogo (tarjetas) la visibilidad se gestiona solo con CSS.
  function updatePdpButtonState() {
    const html = document.documentElement;
    const timeFrame = html.dataset.timeFrame;
    const deliveryOption = html.dataset.deliveryOption;
    const wrapper = document.querySelector('.product_page_template[data-df]');

    if (!wrapper) return;

    const df = wrapper.getAttribute('data-df') || '';
    const buttons = wrapper.querySelectorAll('.js-go-cart-add-to-cart');

    let shouldDisable = false;

    if (timeFrame === 'dias_fuertes') {
      if (deliveryOption === 'pickup' && !df.includes('t')) shouldDisable = true;
      if (deliveryOption === 'delivery' && !df.includes('w')) shouldDisable = true;
    }

    for (const btn of buttons) {
      if (shouldDisable) {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    }
  }

  // Escuchar cuando se cargan las configuraciones de ZapietEats
  document.addEventListener("zapieteats:settings:loaded", assignDateInterval);

  // Re-ejecutar al cambiar modo de entrega (pickup ↔ delivery).
  document.addEventListener("zapieteats:deliveryoption:changed", assignDateInterval);

  // Exponer funciones para uso manual si es necesario
  window.assignDateInterval = assignDateInterval;
  window.updatePdpButtonState = updatePdpButtonState;
})();

// Gestión de clases en ZapietEats-WidgetModal según botón de delivery/pickup seleccionado
$(document).ready(function() {
  // Función para manejar cambios en los botones de delivery/pickup
  function handleDeliveryOptionChange() {
    var modal = $('#ZapietEats-WidgetModal');
    if (!modal.length) {
      return;
    }

    // Buscar los botones de delivery y pickup
    var deliveryButton = $('#delivery');
    var pickupButton = $('#pickup');

    // Verificar qué botón está activo
    var deliveryIsActive = deliveryButton.length && 
                          (deliveryButton.attr('aria-selected') === 'true' || 
                           deliveryButton.hasClass('ZapietEats-DeliveryOption--active'));
    
    var pickupIsActive = pickupButton.length && 
                        (pickupButton.attr('aria-selected') === 'true' || 
                         pickupButton.hasClass('ZapietEats-DeliveryOption--active'));

    // Aplicar clases según el botón activo
    if (deliveryIsActive) {
      modal.removeClass('shpgr-pickup');
      modal.addClass('shpgr-delivery');
    } else if (pickupIsActive) {
      modal.removeClass('shpgr-delivery');
      modal.addClass('shpgr-pickup');
    }
  }

  // Usar event delegation para capturar clicks en los botones
  $(document).on('click', '#delivery, #pickup', function() {
    // Pequeño delay para asegurar que los atributos se actualicen
    setTimeout(function() {
      handleDeliveryOptionChange();
    }, 50);
  });

  // También observar cambios en los atributos aria-selected y clases
  var modalObserver = new MutationObserver(function(mutations) {
    var shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes') {
        var attributeName = mutation.attributeName;
        if (attributeName === 'aria-selected' || attributeName === 'class') {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      handleDeliveryOptionChange();
    }
  });

  // Observar los botones cuando estén disponibles
  function observeButtons() {
    var deliveryButton = document.getElementById('delivery');
    var pickupButton = document.getElementById('pickup');
    
    if (deliveryButton) {
      modalObserver.observe(deliveryButton, {
        attributes: true,
        attributeFilter: ['aria-selected', 'class']
      });
    }
    
    if (pickupButton) {
      modalObserver.observe(pickupButton, {
        attributes: true,
        attributeFilter: ['aria-selected', 'class']
      });
    }
  }

  // Intentar observar cuando el modal se abre
  document.addEventListener('zapieteats:modal:opened', function() {
    setTimeout(function() {
      observeButtons();
      handleDeliveryOptionChange();
    }, 300);
  });

  // También intentar observar cuando cambia la opción de delivery
  document.addEventListener('zapieteats:deliveryoption:changed', function() {
    setTimeout(function() {
      observeButtons();
      handleDeliveryOptionChange();
    }, 100);
  });

  // Intentar observar inmediatamente si los botones ya existen
  setTimeout(function() {
    observeButtons();
    handleDeliveryOptionChange();
  }, 1000);
});